import logo from './logo.svg';
import './App.css';
import SearchPage from './Components/SearchPage';
import Spell from './Components/Spell';
import { BrowserRouter, Routes, Route} from "react-router";
import {React, useState, useEffect} from 'react';



function App() {
  const   [   spellList,          setSpellList          ]   =   useState([]);
  const   [   searchFilters,   setSearchFilters   ]   =   useState({
    "class"       :   "wiz",
    "level-lo"    :   "0",
    "level-hi"    :   "9",
    "school"      :   "",
    "subschool"   :   "",
    "tag"         :   [],
    "verbal"      :   false,
    "somatic"     :   false,
    "material"    :   false,
    "cost"        :   false,
    "spellFocus"  :   false,
    "divineFocus" :   false,
  })



  useEffect(() => {
    console.log(spellList);
  })



  return (

    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
        <div className="App-body">

          <Routes>
              <Route path="/" element={<SearchPage spellList={spellList} setSpellList={setSpellList} searchFilters={searchFilters} setSearchFilters={setSearchFilters}/>} />
              <Route path="/spell/:spellId" element={<Spell/>}/>
            </Routes>
        </div>
        <footer>
          <br/><br/>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;